import {getContainer} from "./getContainer";
import useTailwindConfig from './useTailwindConfig';

const fullConfig = useTailwindConfig();

export const openMobileFilters = () => {
    //-- Force filter menu to start at top of viewport for full-height behavior
    const filters = document.querySelector("[data-target-parent='filters']");
    filters.style.top = "0px";
};

//-- Calculate offset for sticky-filter-btn on category.tpl + open filters + cashbacks
export const initOffsetSticky = (container = document.body) => {
    container = getContainer(container);
    const filterButtons = document.querySelectorAll('.sticky-filter-btn');
    if (filterButtons) {
        filterButtons.forEach(filterButton => {
            container.style.paddingBottom = (filterButton.firstElementChild.offsetHeight + 20) + 'px';
        });
    }
};

export const isSmallScreen = (width) => width < parseInt(fullConfig.theme.screens.lg);

export const getHeightHeaderAddOffset = () => {
    const headerHeight = document.getElementById('fixedHeader').offsetHeight;
    const stickySection = document.querySelector('[data-sticky]');
    if (stickySection) {
        stickySection.style.top = ' ' + (headerHeight + 32) + 'px';
    }
};